import { render, staticRenderFns } from "./TestBroadcast2Dialog.vue?vue&type=template&id=ee1104d8"
import script from "./TestBroadcast2Dialog.vue?vue&type=script&lang=js"
export * from "./TestBroadcast2Dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports